import axios from "axios";

const url = process.env.REACT_APP_BACKEND_URL;

export const GetLogin = async (gidecekData) => {
  return await axios.post(url + "login", gidecekData);
};
